
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_499_4559)","fill":"#000"}},[_c('path',{attrs:{"d":"M4.963 4.967C4.96 2.238 7.177.004 9.897 0a4.963 4.963 0 014.963 4.938c.013 2.741-2.222 4.988-4.95 4.988-2.717 0-4.943-2.23-4.951-4.959h.004zm4.938 3.709a3.726 3.726 0 003.73-3.697c.008-2.05-1.675-3.745-3.717-3.745-2.018 0-3.705 1.674-3.713 3.688a3.725 3.725 0 003.705 3.75l-.005.004zM9.934 11.113c1.324.058 2.602.278 3.82.8.412.18.571.491.432.85-.126.323-.473.442-.886.29-1.295-.482-2.622-.743-4.007-.62-2.986.261-5.257 1.69-6.83 4.227-.804 1.303-1.2 2.741-1.22 4.277-.01.49-.185.723-.544.756-.45.04-.71-.217-.703-.707.017-.993.143-1.973.474-2.913 1.266-3.602 3.762-5.849 7.48-6.707.644-.146 1.318-.171 1.98-.253h.004z"}}),_c('path',{attrs:{"d":"M16.96 11.636l1.25 2.537c.09.18.261.306.461.335l2.798.408a.615.615 0 01.34 1.05l-2.027 1.977a.612.612 0 00-.175.543l.477 2.79a.615.615 0 01-.89.65L16.69 20.61a.615.615 0 00-.572 0l-2.504 1.315a.615.615 0 01-.89-.65l.478-2.789a.62.62 0 00-.176-.543L11 15.966a.616.616 0 01.34-1.05l2.797-.408a.615.615 0 00.462-.335l1.25-2.537a.615.615 0 011.103 0h.008z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_499_4559"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h22v22H0z"}})])])])
          )
        }
      }
    